(function () {
  class PackProduct extends HTMLElement {
    constructor() {
      super();
      this.inventoryQuantity = 0;
      this.inventoryPolicy = '';
    }

    connectedCallback() {
      this.inventoryQuantity = parseInt(this.getAttribute('data-inventory-quantity')) || 0;
      this.inventoryPolicy = this.getAttribute('data-inventory-policy');

      this.thumbnails = this.querySelectorAll('[data-pack-thumbnail]');
      this.mediaItems = this.querySelectorAll('[data-pack-media]');
      this.quantityInput = this.querySelector('[data-pack-qty-input]');
      this.btnPlus = this.querySelector('[data-pack-qty-plus]');
      this.btnMinus = this.querySelector('[data-pack-qty-minus]');
      this.addToCartBtn = this.querySelector('[data-pack-add-to-cart]');

      this.setupGallery();
      this.setupQuantity();
      this.setupAddToCart();
      this.setupReadMore();
      this.checkStockAvailability();
    }

    setupGallery() {
      this.thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => {
          const index = thumbnail.dataset.mediaIndex;

          this.thumbnails.forEach((t) => t.classList.remove('active'));
          thumbnail.classList.add('active');

          this.mediaItems.forEach((item) => {
            if (item.dataset.mediaIndex === index) {
              item.classList.add('active');
            } else {
              item.classList.remove('active');
              const video = item.querySelector('video');
              if (video) video.pause();
              // Note : pour une vraie coupure du son des iframes YouTube/Vimeo,
              // il faudrait passer par leur API postMessage (non implémenté ici).
            }
          });
        });
      });
    }

    setupQuantity() {
      const priceElement = this.querySelector('[data-pack-price]');
      if (!priceElement || !this.quantityInput) return;

      const basePrice = parseInt(priceElement.dataset.basePrice, 10);
      const moneyFormat = this.getAttribute('data-money-format') || '';

      const maxQuantity = this.inventoryPolicy === 'continue' ? 999 : this.inventoryQuantity;
      this.quantityInput.max = maxQuantity;

      const formatMoney = (cents) => {
        // Utilise le format de la boutique si transmis (via {{ shop.money_format }}),
        // sinon repli simple en euros — évite de coder EUR/fr-FR en dur.
        if (moneyFormat) {
          return moneyFormat.replace('{{amount}}', (cents / 100).toFixed(2).replace('.', ','));
        }
        return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100);
      };

      const updateButtonsState = (qty) => {
        if (this.btnMinus) this.btnMinus.disabled = qty <= 1;
        if (this.btnPlus) this.btnPlus.disabled = qty >= maxQuantity;
      };

      const updatePrice = (qty) => {
        if (!isNaN(basePrice)) {
          priceElement.innerHTML = formatMoney(basePrice * qty);
        }
      };

      this.btnMinus?.addEventListener('click', () => {
        let val = parseInt(this.quantityInput.value, 10) || 1;
        if (val > 1) {
          val--;
          this.quantityInput.value = val;
          updatePrice(val);
          updateButtonsState(val);
        }
      });

      this.btnPlus?.addEventListener('click', () => {
        let val = parseInt(this.quantityInput.value, 10) || 1;
        if (val < maxQuantity) {
          val++;
          this.quantityInput.value = val;
          updatePrice(val);
          updateButtonsState(val);
        }
      });

      this.quantityInput.addEventListener('change', () => {
        let qty = parseInt(this.quantityInput.value, 10) || 1;
        if (qty < 1) qty = 1;
        if (qty > maxQuantity) qty = maxQuantity;
        this.quantityInput.value = qty;
        updatePrice(qty);
        updateButtonsState(qty);
      });

      updateButtonsState(parseInt(this.quantityInput.value, 10) || 1);
    }

    checkStockAvailability() {
      if (this.inventoryQuantity <= 0 && this.inventoryPolicy !== 'continue') {
        if (this.addToCartBtn) {
          this.addToCartBtn.disabled = true;
          this.addToCartBtn.querySelector('.button-text').textContent = 'Rupture de stock';
          this.addToCartBtn.classList.add('is-out-of-stock');
        }
        if (this.btnPlus) this.btnPlus.disabled = true;
        if (this.btnMinus) this.btnMinus.disabled = true;
        if (this.quantityInput) this.quantityInput.disabled = true;
      }
    }

    setupAddToCart() {
      if (!this.addToCartBtn) return;

      this.addToCartBtn.addEventListener('click', () => {
        if (this.addToCartBtn.disabled) return;

        const variantId = this.addToCartBtn.dataset.variantId;
        const quantity = parseInt(this.quantityInput.value, 10) || 1;
        const maxQuantity = this.inventoryPolicy === 'continue' ? 999 : this.inventoryQuantity;

        if (quantity > maxQuantity && this.inventoryPolicy !== 'continue') {
          alert('Désolé, la quantité demandée dépasse notre stock disponible.');
          return;
        }

        const originalText = this.addToCartBtn.querySelector('.button-text').textContent;
        this.addToCartBtn.disabled = true;
        this.addToCartBtn.classList.remove('is-out-of-stock', 'is-error');
        this.addToCartBtn.querySelector('.button-text').textContent = 'Ajout...';

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] }),
        })
          .then(async (response) => {
            const data = await response.json();
            if (!response.ok) {
              // On remonte le vrai message renvoyé par Shopify (stock, variante invalide, etc.)
              throw new Error(data.description || 'Erreur lors de l\'ajout au panier');
            }
            return data;
          })
          .then((data) => {
            this.addToCartBtn.querySelector('.button-text').textContent = 'Ajouté !';
            this.addToCartBtn.classList.add('is-success');
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: data } }));

            setTimeout(() => {
              this.addToCartBtn.querySelector('.button-text').textContent = originalText;
              this.addToCartBtn.classList.remove('is-success');
              this.addToCartBtn.disabled = false;
            }, 2000);
          })
          .catch((error) => {
            console.error('Erreur panier :', error);
            this.addToCartBtn.querySelector('.button-text').textContent = error.message || 'Erreur';
            this.addToCartBtn.classList.add('is-error');

            setTimeout(() => {
              this.addToCartBtn.querySelector('.button-text').textContent = originalText;
              this.addToCartBtn.classList.remove('is-error');
              this.addToCartBtn.disabled = false;
            }, 2500);
          });
      });
    }

    setupReadMore() {
      const btn = this.querySelector('[data-pack-read-more]');
      const content = this.querySelector('[data-pack-description-content]');
      if (!btn || !content) return;

      btn.addEventListener('click', () => {
        content.classList.toggle('expanded');
        btn.textContent = content.classList.contains('expanded') ? 'RÉDUIRE' : 'LIRE LA SUITE';
      });
    }
  }

  if (!customElements.get('pack-product')) {
    customElements.define('pack-product', PackProduct);
  }
})();
